"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSmallShift = exports.isBetweenDates = exports.getRangeNightsString = exports.getFlexEndDatesFromNights = exports.getEndDateTo = exports.getEndDateFrom = exports.getCornerDates = void 0;

var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));

var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));

var _differenceInDays = _interopRequireDefault(require("date-fns/differenceInDays"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _utils = require("../../../../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isBetweenDates = function isBetweenDates(date, interval) {
  if (!interval.start || !interval.end) return false;
  return (0, _isWithinInterval["default"])(date, interval);
};

exports.isBetweenDates = isBetweenDates;

var isSmallShift = function isSmallShift(shift) {
  return shift < 2;
};
/* TODO: Эта группа TODO будем искать их по ключевому слову СПАСИТЕ ниже описание
export const getShiftFromFlexDates = (flexDates: FlexDates): DateCell['shift'] => {
  const { from, to, primary } = flexDates;

  return {
    left: differenceInDays(primary, from),
    right: differenceInDays(to, primary),
  };
};
*/


exports.isSmallShift = isSmallShift;

var getCornerDates = function getCornerDates(_ref) {
  var date = _ref.date,
      shift = _ref.shift;
  var formatDate = date instanceof Date ? date : new Date(date || 0);
  return {
    from: (0, _addDays["default"])(formatDate, -shift),
    to: (0, _addDays["default"])(formatDate, shift)
  };
};

exports.getCornerDates = getCornerDates;

var getEndDateFrom = function getEndDateFrom(startCornerDates, nights, isFlexNights) {
  if (isFlexNights) {
    return (0, _addDays["default"])(startCornerDates.to, nights.from);
  }

  return (0, _addDays["default"])(startCornerDates.from, nights.from);
};

exports.getEndDateFrom = getEndDateFrom;

var getEndDateTo = function getEndDateTo(startCornerDates, nights, isFlexNights) {
  if (isFlexNights) {
    return (0, _addDays["default"])(startCornerDates.from, nights.to);
  }

  return (0, _addDays["default"])(startCornerDates.to, nights.to);
};

exports.getEndDateTo = getEndDateTo;

var getFlexEndDatesFromNights = function getFlexEndDatesFromNights(startDateCell, shift, nights) {
  var startCornerDates = getCornerDates({
    date: startDateCell.date,
    shift: shift
  });
  var isFlexNights = nights.from !== nights.to;
  var from = getEndDateFrom(startCornerDates, nights, isFlexNights);
  var to = getEndDateTo(startCornerDates, nights, isFlexNights);
  var isFromAfterTo = (0, _isAfter["default"])(from, to);
  return {
    from: from,
    to: to,
    primary: isFromAfterTo ? null : new Date((0, _utils.getMidnightFromString)((from.getTime() + to.getTime()) / 2))
  };
};

exports.getFlexEndDatesFromNights = getFlexEndDatesFromNights;

var getRangeNightsString = function getRangeNightsString(_ref2) {
  var startDateCell = _ref2.startDateCell,
      endDateCell = _ref2.endDateCell;
  var startDate = startDateCell.date;
  var endDate = endDateCell.date;

  if (!startDate || !endDate) {
    return;
  }

  return {
    from: (0, _differenceInDays["default"])(endDate, startDate),
    to: (0, _differenceInDays["default"])(endDate, startDate)
  };
};

exports.getRangeNightsString = getRangeNightsString;